import * as React from "react";
import type { SVGProps } from "react";
const SvgDownloadFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#download-file_svg__a)">
      <path d="M12 14c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1" />
      <path d="M12 15c-.26 0-.51-.1-.71-.29l-3-3A.996.996 0 1 1 9.7 10.3l2.29 2.29 2.29-2.29a.996.996 0 1 1 1.41 1.41l-3 3c-.2.2-.45.29-.71.29zM15 18H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1" />
      <path d="M20 22H4c-.55 0-1-.45-1-1V7c0-.27.11-.52.29-.71l4-4A1 1 0 0 1 8 2h12c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1M5 20h14V4H8.41L5 7.41z" />
      <path d="M8 8H4c-.55 0-1-.45-1-1s.45-1 1-1h3V3c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="download-file_svg__a">
        <path fill="#fff" d="M3 2h18v20H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDownloadFile;
